export default function getCustomerWishlistOperation() {
    function getCustomerWishlist() {
        return {
            wishlist: {}
        };
    }
    return getCustomerWishlist;
};
